var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('HeaderMenu'),_c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"app-menu"},[_c('ProductBox')],1)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline-title"},[_c('div',{staticClass:"headline-title-content"},[_vm._v(" LINENAZI ")])])
}]

export { render, staticRenderFns }